import { Currency } from '@/types';
import getCurrencyFractionDigits from './currency/getCurrencyFractionDigits';
import displayCurrency from './currency/displayCurrency';

export type ValueFormatConfig = {
  ratio?: number;
  symbol?: string;
  compact?: boolean;
  currency: Currency;
  currencyRate: number;
};
export function valueFormat(
  value: number | undefined,
  config: ValueFormatConfig,
): string | undefined {
  if (value === undefined) return undefined;

  const ratio = config.ratio || 1;
  const currency = config.currency;
  const symbol = currency.symbol;
  const compact = config.compact || false;
  const fractionDigits = getCurrencyFractionDigits(config.currencyRate);

  const formatter = getFormatter(compact, fractionDigits);

  const isNeg = value < 0;
  let formattedValue = Math.abs(value * config.currencyRate * ratio);
  let tooSmall = false;
  if (
    !compact &&
    formattedValue !== 0 &&
    formattedValue < 10 ** -fractionDigits
  ) {
    tooSmall = true;
    formattedValue = 10 ** -fractionDigits;
  }
  return `${tooSmall ? '<' : ''}${
    isNeg ? '-' : ''
  }${displayCurrency(formatter.format(formattedValue), symbol, currency.symbolPosition)}`;
}

function getFormatter(compact: boolean, fractionDigits: number) {
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
    compactDisplay: compact ? 'short' : undefined,
    notation: compact ? 'compact' : undefined,
    roundingMode: compact ? 'floor' : undefined,
  });
}
